<!-- 排出事業者 事業場 -->
<template>
  <div>
    <v-card flat>
      <v-toolbar flat>
        <v-spacer />
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          事業場の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-sheet outlined rounded>
          <v-data-table
            :headers="tableHeaders"
            :items="emissionLocations"
            :items-per-page="-1"
            dense
            disable-sort
            hide-default-footer
          >
            <template v-slot:[`item.name`]="{ item }">
              <span :title="item.name">{{ item.name | truncate(20) }}</span>
            </template>

            <template v-slot:[`item.address`]="{ item }">
              <div>〒{{ item.zip_code }}</div>
              <span>{{ item.address | truncate(25) }}</span>
            </template>

            <template v-slot:[`item.memo`]="{ item }">
              <span :title="item.memo">{{ item.memo | truncate(20) }}</span>
            </template>

            <template v-slot:[`item.editable`]="{ item }">
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :small="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                :class="{ 'mr-2': $vuetify.breakpoint.smAndDown }"
                @click="editButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-file-edit-outline
                </v-icon>
                <span v-else>編集</span>
              </v-btn>
              <v-btn
                v-if="!isDemoEnv"
                :icon="$vuetify.breakpoint.mdAndUp"
                :small="$vuetify.breakpoint.smAndDown"
                :color="`error ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="deleteButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-trash-can-outline
                </v-icon>
                <span v-else>削除</span>
              </v-btn>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
        <v-spacer />
      </v-card-actions>
    </v-card>

    <location-dialog
      :enable-dialog="enableLocationDialog"
      :master-emission="masterEmission"
      :emission-id="emissionId"
      :target-id="targetLocationId"
      @closeEvent="closeLocationDialog"
      @registerEvent="locationDialogCallback"
    />
    <confirm ref="confirm" />

    <v-dialog
      v-model="enableRemoveConfirmation"
      persistent
      width="600"
    >
      <v-card>
        <v-toolbar color="error" dark flat>
          <v-toolbar-title>確認</v-toolbar-title>
        </v-toolbar>
        <v-divider />
          <v-card-text>
            <v-container>
              <h3 style="white-space:pre-wrap; word-wrap:break-word;">
                担当者が紐付けられている事業場は削除出来ません
              </h3>
            </v-container>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeLocationDialog"
            >
              閉じる
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import LocationDialog from '../dialogs/_LocationDialog'
import Confirm from '../../../../../components/Confirm'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'EmissionLocationForm',
  components: {
    Confirm,
    LocationDialog
  },
  mixins: [
  ],
  props: {
    masterEmission: {
      type: Object,
      default: () => {},
    }
  },
  data () {
    return {
      enableLocationDialog: false,
      emissionId: null,
      targetLocationId: null,
      tableHeaders: [
        { value: 'code', text: '事業場コード' },
        { value: 'name', text: '事業場名' },
        { value: 'address', text: '住所' },
        { value: 'phone_number', text: '電話番号' },
        { value: 'memo', text: 'メモ欄' },
        { value: 'sort_priority', text: '表示順', align: 'right' },
        { value: 'editable', text: '', align: 'end' },
      ],
      page: 1,
      totalVisible: 7,
      pagination: {
        total_pages: 0,
        total_count: 0
      },
      emissionLocations: [],
      enableRemoveConfirmation: false,
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'isDemoEnv',
    ]),
  },
  created () {
    this.emissionId = Number(this.$route.params.id)
    this.searchEmissionLocations()
  },
  methods: {
    ...mapActions('DriverMasterEmissionLocation', {
      'fetchEmissionLocations': 'index',
      'deleteEmissionLocation' : 'destroy',
    }),
    ...mapActions('DriverMasterEmissionLocationRemoveConfirmation', {
      fetchCanRemoveLocation: 'show'
    }),
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.targetLocationId = null
      this.enableLocationDialog = true
    },
    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
    editButtonClickEvent (item) {
      this.targetLocationId = item.id
      this.enableLocationDialog = true
    },
    /**
     * 削除ボタン クリックイベント
     * @param item { Object }
     */
    deleteButtonClickEvent (item) {
      /**
       * @param content { Object }
       * @property content.user_exists { Boolean } ユーザー紐付
       */
      this.fetchCanRemoveLocation({ emission_id: this.emissionId, location_id: item.id }).then((content) => {
        if (content.user_exists) {
          // 紐付くユーザーが存在する場合は、カスタムメッセージを表示
          this.hasUserRemoveConfirm(item)
        } else {
          // 紐付くユーザーが存在しない場合は、通常の確認メッセージを表示
          this.regularRemoveConfirm(item)
        }
      })
    },
    /**
     * モーダルを閉じる
     */
    closeLocationDialog () {
      this.enableLocationDialog = false
      this.enableRemoveConfirmation = false
    },
    /**
     * モーダルからのコールバック処理
     */
    locationDialogCallback () {
      this.enableLocationDialog = false
      this.searchEmissionLocations()
    },
    /**
     * ページ チェンジイベント
     */
    changePage () {
      this.searchEmissionLocations()
    },
    /**
     * 排出事業場検索
     */
    searchEmissionLocations () {
      this.fetchEmissionLocations({ emission_id: this.$route.params.id , page: this.page}).then((content) => {
        this.emissionLocations = content.locations
        this.pagination = content.pagination
      })
    },
    /**
     *
     */
    regularRemoveConfirm (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteEmissionLocation({ emission_id: this.emissionId, id: item.id }).then(() =>{
            this.page = 1
            this.searchEmissionLocations()
          })
        }
      })
    },
    hasUserRemoveConfirm (item) {
      // this.targetLocationId = item.id
      this.enableRemoveConfirmation = true
    },
    removeButtonClickEvent () {
      this.deleteEmissionLocation({ emission_id: this.emissionId, id: this.targetLocationId }).then(() =>{
        this.targetLocationId = null;
        this.closeLocationDialog();
        this.page = 1
        this.searchEmissionLocations()
      })
    },
  },
}
</script>

<style scoped lang="scss">
.wrap_text {
  display: inline-block;
  overflow-wrap: break-word;
}
</style>
